{
  "brand": {
    "name": "Sigma08",
    "tagline": "AI-Powered Learning Platform",
    "description": "Transform education with personalized AI-driven learning experiences"
  },
  "actions": {
    "submit": "Submit",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "download": "Download",
    "upload": "Upload",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "confirm": "Confirm",
    "retry": "Retry",
    "loading": "Loading...",
    "processing": "Processing..."
  },
  "status": {
    "success": "Success",
    "error": "Error",
    "warning": "Warning",
    "info": "Information",
    "pending": "Pending",
    "active": "Active",
    "inactive": "Inactive",
    "completed": "Completed",
    "failed": "Failed",
    "cancelled": "Cancelled"
  },
  "time": {
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "thisWeek": "This Week",
    "lastWeek": "Last Week",
    "thisMonth": "This Month",
    "lastMonth": "Last Month",
    "thisYear": "This Year",
    "lastYear": "Last Year",
    "seconds": "seconds",
    "minutes": "minutes",
    "hours": "hours",
    "days": "days",
    "weeks": "weeks",
    "months": "months",
    "years": "years"
  },
  "pagination": {
    "page": "Page",
    "of": "of",
    "items": "items",
    "showing": "Showing",
    "to": "to",
    "perPage": "Per page",
    "goToPage": "Go to page"
  },
  "currency": {
    "symbol": "$",
    "code": "USD"
  },
  "language": {
    "select": "Select Language",
    "current": "English",
    "switch": "Switch to Portuguese"
  },
  "region": {
    "select": "Select Region",
    "current": "United States",
    "switch": "Switch Region"
  }
}
